import template from './dashboard.html';
import controller from './dashboard.controller';
import './dashboard.scss';

const dashboardComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

controller.$inject = ['$scope', '$timeout', '$uibModal', 'projectService'];

export default dashboardComponent;
